







































import { computed } from '@vue/composition-api'
import { dcb } from '@dcb/jssdk'
import { defineClassComponent } from '@/hooks'
import { goodsProvider } from '../provider'

export default defineClassComponent(
  {},
  () =>
    class {
      // 商品数据
      goodsData = goodsProvider.inject()

      // 虚拟活动数据
      virtualActivityData = computed(
        () => this.goodsData.value.virtualActivityData,
      )

      jumpRouteUrl = () => {
        dcb.navigateTo({
          url: this.virtualActivityData.value.commodityRouteUrl,
        })
      }
    },
)
